import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { RespondToActivationRequest } from '../../../models';
import { RespondToActivationRequestService } from '../../../services';
import { AcceptFormComponent } from './accept-form.component';

@Component({
  selector: 'nexweb-acceptance',
  templateUrl: './acceptance.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AcceptFormComponent, AsyncPipe],
})
export class AcceptanceComponent implements OnInit {
  @Input() bidId: number;

  public notification$: Observable<RespondToActivationRequest.Notification>;
  public labels: RespondToActivationRequest.NotificationLabels;
  public dateTimeFormat: string;
  public heading: string;

  private respondToActivationRequestService = inject(RespondToActivationRequestService);
  private bmFacade = inject(BmDataAccessFacade);

  ngOnInit(): void {
    this.labels = this.respondToActivationRequestService.getAcceptanceLabels();
    this.dateTimeFormat = this.respondToActivationRequestService.getDateTimeFormat();
    this.heading = this.respondToActivationRequestService.getAcceptanceHeading();

    this.initialiseData();
  }

  private initialiseData(): void {
    this.notification$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map((bidNotificationInfo: BidNotificationInfo) => {
        const bidNotificationData = {
          instrument: bidNotificationInfo.instrument,
          activatingPortfolio: bidNotificationInfo.requestingTsoPortfolioName,
          supplyingBspPortfolio: bidNotificationInfo.supplyingBspPortfolioName,
          activatedQuantity: bidNotificationInfo.requestedQuantity,
          confirmedActivationTime: bidNotificationInfo.confirmedFullDispatchTime,
          timeRequestWasAccepted: bidNotificationInfo.acceptTime,
        } as RespondToActivationRequest.Notification;

        return bidNotificationData;
      }),
    );
  }
}
